import { KeyboardEventHandler, ReactElement, useEffect, useState } from "react"
import MultiSelect, { MultiSelectOption } from "./MultiSelect"

import { MultiValue } from "react-select"
import { z } from "zod"

const Values = z.array(z.string())
type Values = z.infer<typeof Values>

export default function MultiSelectWrapper(args: {
	alternatives: MultiSelectOption[]
	initialValues: string[]
	onChange: (newValues: string[]) => void
	onKeyDown?: KeyboardEventHandler
	isClearable?: boolean
	required?: boolean
	error?: boolean
	warning?: boolean
	tabIndex?: number
	maxAmountItems?: number
	placeHolderText?: string
	minAmountItems?: number
	isDisabled?: boolean
	selectedItemsNoun?: string
	useCompactSelectionSummary?: boolean
	isSingleColumn?: boolean
}): ReactElement {
	const initialValues = args.alternatives.filter(
		(alt) => args.initialValues.includes(alt.value) && alt.isDisabled !== true
	)
	const [selectedOptions, setSelectedOptions] =
		useState<MultiValue<MultiSelectOption>>(initialValues)

	useEffect(() => {
		setSelectedOptions(
			args.alternatives.filter(
				(alt) => args.initialValues.includes(alt.value) && alt.isDisabled !== true
			)
		)
	}, [JSON.stringify(initialValues.map((v) => v.value))])

	useEffect(() => {
		args.onChange(selectedOptions.map((o) => o.value))
	}, [selectedOptions])

	async function parseClipboard() {
		const text = await navigator.clipboard.readText()
		const values = Values.parse(JSON.parse(text))
		const selected = args.alternatives.filter(
			(alt) => values.includes(alt.value) && alt.isDisabled !== true
		)
		setSelectedOptions(selected)
	}

	const keyDown: KeyboardEventHandler = (event) => {
		if (!event.ctrlKey) {
			return
		}
		if (event.key == "c") {
			event.preventDefault()
			const values = JSON.stringify(selectedOptions.map((so) => so.value))
			navigator.clipboard.writeText(values)
		}
		if (event.key == "v") {
			event.preventDefault()
			parseClipboard().catch(console.error)
		}
	}

	return (
		<MultiSelect
			isDisabled={args.isDisabled}
			placeHolderText={args.placeHolderText}
			warning={args.warning}
			required={args.required}
			error={args.error}
			tabIndex={args.tabIndex}
			onChange={setSelectedOptions}
			options={args.alternatives}
			value={selectedOptions}
			onKeyDown={keyDown}
			isClearable={args.isClearable ?? true}
			maxAmountItems={args.maxAmountItems}
			minAmountItems={args.minAmountItems}
			selectedItemsNoun={args.selectedItemsNoun}
			useCompactSelectionSummary={args.useCompactSelectionSummary}
			isSingleColumn={args.isSingleColumn}
		/>
	)
}
